/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from 'zod/v4'

export const putUsersMeStatus200Schema = z.object({
  email: z.email().optional(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  locale: z.string(),
  organizationId: z.string().optional(),
})

export const putUsersMeStatus400Schema = z.string()

export const putUsersMeStatus401Schema = z.string()

export const putUsersMeStatus403Schema = z.string()

export const putUsersMeStatus404Schema = z.string()

export const putUsersMeStatus500Schema = z.string()

export const putUsersMeResponseSchema = putUsersMeStatus200Schema

export const putUsersMeErrorSchema = z.union([putUsersMeStatus400Schema, putUsersMeStatus401Schema, putUsersMeStatus403Schema, putUsersMeStatus404Schema, putUsersMeStatus500Schema])
